// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const MenuIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M11.94 18.86c-1 0-1.82.82-1.82 1.82s.82 1.82 1.82 1.82 1.82-.81 1.82-1.82c0-1-.82-1.82-1.82-1.82m0-8.68c-1 0-1.82.82-1.82 1.82s.82 1.82 1.82 1.82S13.76 13 13.76 12s-.82-1.82-1.82-1.82m0-8.68c-1 0-1.82.81-1.82 1.82 0 1 .82 1.81 1.82 1.81s1.82-.81 1.82-1.81-.82-1.82-1.82-1.82" />
      <path
        d="M20.65 18.86c-1 0-1.82.82-1.82 1.82s.81 1.82 1.82 1.82c1 0 1.81-.81 1.81-1.82 0-1-.81-1.82-1.81-1.82m0-8.68c-1 0-1.82.82-1.82 1.82s.81 1.82 1.82 1.82c1 0 1.81-.82 1.81-1.82s-.81-1.82-1.81-1.82m0-5.05c1 0 1.81-.81 1.81-1.81s-.81-1.82-1.81-1.82-1.82.81-1.82 1.82c0 1 .81 1.81 1.82 1.81M3.36 18.86c-1 0-1.82.82-1.82 1.82s.81 1.82 1.82 1.82c1 0 1.81-.81 1.81-1.82 0-1-.81-1.82-1.81-1.82m0-8.68c-1 0-1.82.82-1.82 1.82s.81 1.82 1.82 1.82c1 0 1.81-.82 1.81-1.82s-.81-1.82-1.81-1.82m0-8.68c-1 0-1.82.81-1.82 1.82 0 1 .81 1.81 1.82 1.81 1 0 1.81-.81 1.81-1.81S4.36 1.5 3.36 1.5"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default MenuIcon;
